import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

// lazy import components
const Login = () => import('../components/login/Login');
const FourOhFour = () => import('../components/FourOhFour/FourOhFour');
const ie = () => import('../components/FourOhFour/ie');
const MainVue = () => import('../components/main/main');
const Users = () => import('../components/users/users');
const UserInfo = () => import('../components/users/user-info');
const AddUser = () => import('../components/users/create-new-user');
const DelUser = () => import('../components/users/delete-confirmation');
const Settings = () => import('../components/settings/settings');
const UserSettings = () => import('../components/settings/user');
const FavTrains = () => import('../components/settings/favtrains');
const ANB = () => import('../components/settings/anb');

const Fotodatenbank = () => import('../components/fotodatenbank/fotodatenbank');
const Abbuchen = () => import('../components/fotodatenbank/abbuchen');
const Search = () => import('../components/fotodatenbank/search');
const TrainSelect = () => import('../components/fotodatenbank/train-select');
const ArtDetails = () => import('../components/fotodatenbank/article-details');
const EditArt = () => import('../components/fotodatenbank/edit');
const AddArt = () => import('../components/fotodatenbank/add-article');
const DelArt = () => import('../components/fotodatenbank/delete-confirmation');
const VerifyEmail = () => import('../components/verify-email/verify-email');
const ResetPW = () => import('../components/resetPw/resetPW');
const SendMail = () => import('../components/sendmail/send-mail');

const Terms = () => import('../components/terms/terms');

const Contact = () => import('../components/contact/contact');
const Lager = () => import('../components/lager/lager');
const Bestellfiles = () => import('../components/lager/bestellfiles');
const Minbestand = () => import('../components/lager/minbestand');
const LagerUpload = () => import('../components/lager/uploads');
const Bestandsübersicht = () => import('../components/lager/bestandsübersicht');
const NeueBestellung = () => import('../components/lager/neuebestellung');
const BestellUebersicht = () => import('../components/lager/bestelluebersicht');

const Stao = () => import('../components/stao/stao');
const AddStao = () => import('../components/stao/addStao');
const StaoInfo = () => import('../components/stao/staoinfo');
const DelStao = () => import('../components/stao/verifyDel');

Vue.use(Router)

// export default new Router({
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            meta: {
                title: 'Login'
            },
            component: Login,
            props: (route) => ({ path: route.query.p }),
            beforeEnter: (to, from, next) => {
                // if there is a jwt in the store go to home
                if (store.getters['user/jwt']) {
                    next('fotodatenbank/search');
                } else {
                    next();
                }
            }
        },
        {
            path: '/terms',
            name: 'terms',
            meta: {
                title: 'Nutzungsbedingungen'
            },
            component: Terms,
            props: (route) => ({ path: route.query.p }),
            beforeEnter: (to, from, next) => {
                console.log(to);
                // if there is a jwt in the store go to home
                if (store.getters['user/jwt']) {
                    if (store.getters['user/terms'] === 1) {
                        const path = to.fullPath.split('=')[1].replace(/%2F/g, '/');
                        next(path);
                    } else {
                        next();
                    }
                } else {
                    next('Login');
                }
            }
        },
        {
            path: '/mainvue',
            name: 'mainvue',
            redirect: 'fotodatenbank',
            component: MainVue,
            beforeEnter: (to, from, next) => {
                // if there is a jwt in the store go to home
                if (store.getters['user/jwt']) {
                    if (store.getters['user/terms'] !== 1) {
                        next('/terms?p=' + to.path);
                    } else {
                        next();
                    }
                } else {
                    next('/?p=' + to.path);
                }
            },
            children: [
                {
                    path: '/users',
                    name: 'users',
                    meta: {
                        title: 'User'
                    },
                    component: Users,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('0') > -1) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    },
                    children: [
                        {
                            path: 'info',
                            name: 'userinfo',
                            meta: {
                                title: 'User Infos'
                            },
                            component: UserInfo,
                            children: [
                                {
                                    path: 'verify',
                                    name: 'delfuserverify',
                                    component: DelUser
                                }
                            ]
                        },
                        {
                            path: 'add',
                            name: 'adduser',
                            component: AddUser
                        }
                    ]
                },
                {
                    path: '/sendmail',
                    name: 'sendmail',
                    meta: {
                        title: 'Mail versenden'
                    },
                    component: SendMail,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('0') > -1) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    }
                },
                {
                    path: '/stao',
                    name: 'stao',
                    component: Stao,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('0') > -1) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    },
                    children: [
                        {
                            path: 'addstao',
                            name: 'addstao',
                            component: AddStao
                        },
                        {
                            path: 'staoinfo',
                            name: 'staoinfo',
                            component: StaoInfo
                        },
                        {
                            path: 'verify',
                            name: 'delstaoverify',
                            component: DelStao
                        }
                    ]
                },
                {
                    path: '/settings',
                    name: 'settings',
                    meta: {
                        title: 'Einstellungen'
                    },
                    component: Settings,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('1') > -1) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    },
                    children: [
                        {
                            path: 'usersettings',
                            name: 'usersettings',
                            meta: {
                                title: 'User-Einstellungen'
                            },
                            component: UserSettings
                        },
                        {
                            path: 'favtrains',
                            name: 'favtrains',
                            meta: {
                                title: 'Favoritisierte Züge'
                            },
                            component: FavTrains
                        },
                        {
                            path: 'anb',
                            name: 'anb',
                            meta: {
                                title: 'ANB'
                            },
                            component: ANB
                        }

                    ]
                },
                {
                    path: '/kontakt',
                    name: 'kontakt',
                    meta: {
                        title: 'Kontakt'
                    },
                    component: Contact,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('1') > -1) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    }
                },
                {
                    path: '/lager',
                    name: 'lager',
                    meta: {
                        title: 'Lager'
                    },
                    component: Lager,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('6') > -1 || store.getters['user/autLev'].indexOf('7') > -1 || (store.getters['user/autLev'].indexOf('8') > -1)) {
                            next();
                        } else {
                            next('fotodatenbank');
                        }
                    },
                    children: [
                        {
                            path: 'minbestand/:stao/',
                            name: 'minbestand',
                            meta: {
                                title: 'Mindestbestand'
                            },
                            component: Minbestand,
                            props: true,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if (store.getters['user/autLev'].indexOf('6') > -1) {
                                    next();
                                } else {
                                    next('lager');
                                }
                            }

                        },
                        {
                            path: 'bestellfiles/:stao/',
                            name: 'bestellfiles',
                            meta: {
                                title: 'Bestell-Files'
                            },
                            component: Bestellfiles,
                            props: true,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if (store.getters['user/autLev'].indexOf('6') > -1) {
                                    next();
                                } else {
                                    next('lager');
                                }
                            }

                        },
                        {
                            path: 'neuebestellung/:stao/:verbrauchsMat',
                            name: 'neuebestellung',
                            meta: {
                                title: 'Neue Bestellung'
                            },
                            component: NeueBestellung,
                            props: true,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if ((store.getters['user/autLev'].indexOf('6') > -1) || (store.getters['user/autLev'].indexOf('8') > -1)) {
                                    next();
                                } else {
                                    next('lager');
                                }
                            },
                            children: [

                                {
                                    path: 'artdetails/:artId/',
                                    name: 'neubestellartdetails',
                                    meta: {
                                        title: 'Artikeldetails'
                                    },
                                    component: ArtDetails,
                                    props: true,
                                    children: [
                                        {
                                            path: 'editart/',
                                            name: 'neubestelleditart',
                                            meta: {
                                                title: 'Artikeldetails bearbeiten'
                                            },
                                            component: EditArt,
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('3') > -1) {
                                                    next();
                                                } else {
                                                    next('neubestellung');
                                                }
                                            },
                                            children: [
                                                {
                                                    path: 'editTrainSelect',
                                                    name: 'neubestelleditTrainSelect',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: TrainSelect
                                                },
                                                {
                                                    path: 'delart',
                                                    name: 'neubestelldelart',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: DelArt
                                                }
                                            ]
                                        },
                                        {
                                            path: 'abbuchen',
                                            name: 'abbuchen',
                                            meta: {
                                                title: 'Abbuchen'
                                            },
                                            component: Abbuchen,
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('2') > -1 && store.getters['user/autLev'].indexOf('T') < 0) {
                                                    next();
                                                } else {
                                                    next('artdetails');
                                                }
                                            }
                                        }

                                    ]
                                }

                            ]

                        },
                        {
                            path: 'bestelluebersicht/:stao/:verbrauchsMat/:done',
                            name: 'bestelluebersicht',
                            meta: {
                                title: 'Bestellübersicht'
                            },
                            component: BestellUebersicht,
                            props: true,
                            children: [

                                {
                                    path: 'artdetails/:artId/',
                                    name: 'bestellartdetails',
                                    meta: {
                                        title: 'Artikeldetails'
                                    },
                                    component: ArtDetails,
                                    props: true,
                                    children: [
                                        {
                                            path: 'editart/',
                                            name: 'bestelleditart',
                                            meta: {
                                                title: 'Artikeldetails bearbeiten'
                                            },
                                            component: EditArt,
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('3') > -1) {
                                                    next();
                                                } else {
                                                    next('bestelluebersicht');
                                                }
                                            },
                                            children: [
                                                {
                                                    path: 'editTrainSelect',
                                                    name: 'bestelleditTrainSelect',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: TrainSelect
                                                },
                                                {
                                                    path: 'delart',
                                                    name: 'bestelldelart',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: DelArt
                                                }
                                            ]
                                        },
                                        {
                                            path: 'abbuchen',
                                            name: 'abbuchen',
                                            meta: {
                                                title: 'Abbuchen'
                                            },
                                            component: Abbuchen,
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('2') > -1 && store.getters['user/autLev'].indexOf('T') < 0) {
                                                    next();
                                                } else {
                                                    next('artdetails');
                                                }
                                            }
                                        }

                                    ]
                                }

                            ]

                        },
                        {
                            path: 'upload/:stao',
                            name: 'upload',
                            meta: {
                                title: 'Upload'
                            },
                            component: LagerUpload,
                            props: true,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if (store.getters['user/autLev'].indexOf('6') > -1) {
                                    next();
                                } else {
                                    next('lager');
                                }
                            }
                        },
                        {
                            path: 'bestandsuebersicht/:stao',
                            name: 'bestandsuebersicht',
                            meta: {
                                title: 'Bestandsübersicht'
                            },
                            component: Bestandsübersicht,
                            props: true,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if (store.getters['user/autLev'].indexOf('6') > -1) {
                                    next();
                                } else {
                                    next('lager');
                                }
                            },
                            children: [

                                {
                                    path: 'artdetails/:artId/',
                                    name: 'bestandartdetails',
                                    meta: {
                                        title: 'Artikeldetails'
                                    },
                                    component: ArtDetails,
                                    props: true,
                                    children: [
                                        {
                                            path: 'editart/',
                                            name: 'bestandeditart',
                                            component: EditArt,
                                            meta: {
                                                title: 'Artikeldetails bearbeiten'
                                            },
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('3') > -1) {
                                                    next();
                                                } else {
                                                    next('bestandartdetails');
                                                }
                                            },
                                            children: [
                                                {
                                                    path: 'editTrainSelect',
                                                    name: 'bestandeditTrainSelect',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: TrainSelect
                                                },
                                                {
                                                    path: 'delart',
                                                    name: 'bestanddelart',
                                                    meta: {
                                                        title: 'Artikeldetails bearbeiten'
                                                    },
                                                    component: DelArt
                                                }
                                            ]
                                        },
                                        {
                                            path: 'abbuchen',
                                            name: 'bestandabbuchen',
                                            meta: {
                                                title: 'Abbuchen'
                                            },
                                            component: Abbuchen,
                                            props: true,
                                            beforeEnter: (to, from, next) => {
                                                // check if autlev is ok for this page
                                                if (store.getters['user/autLev'].indexOf('2') > -1 && store.getters['user/autLev'].indexOf('T') < 0) {
                                                    next();
                                                } else {
                                                    next('bestandartdetails');
                                                }
                                            }
                                        }

                                    ]
                                }

                            ]
                        }

                    ]
                },
                {
                    path: '/fotodatenbank',
                    name: 'fotodatenbank',
                    meta: {
                        title: 'Fotodatenbank'
                    },
                    component: Fotodatenbank,
                    beforeEnter: (to, from, next) => {
                        // check if autlev is ok for this page
                        if (store.getters['user/autLev'].indexOf('2') > -1) {
                            next();
                        } else {
                            next('FourOhFour');
                        }
                    },
                    children: [
                        {
                            path: 'search',
                            name: 'search',
                            meta: {
                                title: 'Suche'
                            },
                            component: Search,
                            children: [
                                {
                                    path: 'trainSelect',
                                    name: 'trainSelect',
                                    meta: {
                                        title: 'Suche'
                                    },
                                    component: TrainSelect
                                }
                            ]
                        },
                        {
                            path: 'artdetails/:artId/:stao/',
                            name: 'artdetailsFDB',
                            meta: {
                                title: 'Artikeldetails'
                            },
                            component: ArtDetails,
                            props: true,
                            children: [
                                {
                                    path: 'editart/',
                                    name: 'editart',
                                    meta: {
                                        title: 'Artikeldetails bearbeiten'
                                    },
                                    component: EditArt,
                                    props: true,
                                    beforeEnter: (to, from, next) => {
                                        // check if autlev is ok for this page
                                        if (store.getters['user/autLev'].indexOf('3') > -1) {
                                            next();
                                        } else {
                                            next('artdetailsFDB');
                                        }
                                    },
                                    children: [
                                        {
                                            path: 'editTrainSelect',
                                            name: 'editTrainSelect',
                                            meta: {
                                                title: 'Artikeldetails bearbeiten'
                                            },
                                            component: TrainSelect
                                        },
                                        {
                                            path: 'delart',
                                            name: 'delart',
                                            meta: {
                                                title: 'Artikeldetails bearbeiten'
                                            },
                                            component: DelArt
                                        }
                                    ]
                                },
                                {
                                    path: 'abbuchen',
                                    name: 'abbuchen',
                                    meta: {
                                        title: 'Abbuchen'
                                    },
                                    component: Abbuchen,
                                    props: true,
                                    beforeEnter: (to, from, next) => {
                                        // check if autlev is ok for this page
                                        if (store.getters['user/autLev'].indexOf('2') > -1 && store.getters['user/autLev'].indexOf('T') < 0) {
                                            next();
                                        } else {
                                            next('artdetailsFDB');
                                        }
                                    }
                                }
                            ]
                        },

                        {
                            path: 'addart',
                            name: 'addart',
                            meta: {
                                title: 'Artikel hinzufügen'
                            },
                            component: AddArt,
                            beforeEnter: (to, from, next) => {
                                // check if autlev is ok for this page
                                if (store.getters['user/autLev'].indexOf('3') > -1) {
                                    next();
                                } else {
                                    next('artdetails');
                                }
                            },
                            children: [
                                {
                                    path: 'addTrainSelect',
                                    name: 'addTrainSelect',
                                    meta: {
                                        title: 'Artikel hinzufügen'
                                    },
                                    component: TrainSelect
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/verifyemail',
            name: 'verifyemail',
            meta: {
                title: 'E-Mail verifizieren'
            },
            component: VerifyEmail
        },
        {
            path: '/resetPW',
            name: 'resetpw',
            meta: {
                title: 'Passwort zurücksetzen'
            },
            component: ResetPW
        },
        {
            path: '*',
            name: 'FourOhFour',
            meta: {
                title: '404: Seite nicht gefunden'
            },
            component: FourOhFour,
            beforeEnter: (to, from, next) => {
                if (store.getters['user/jwt']) {
                    next();
                } else {
                    next('/');
                }
            }
        },
        {
            path: '/ie',
            name: 'ie',
            meta: {
                title: 'Internet Explorer ist tod.'
            },
            component: ie
        }
    ]
});

export default router;
